export class WeekOfYear {
    public weekNumber: number;
    public start: Date;
    public end: Date;
    public displayValue: string;

    constructor();
    constructor(json: any);
    constructor(json?: WeekOfYear) {
        if (json) {
            this.weekNumber = json.weekNumber;
            this.start = json.start;
            this.end = json.end;
            this.displayValue = json.displayValue;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/week-of-year.ts